import {
  Component,
  EventEmitter,
  Output,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
  Project,
  ModalService,
  ProjectManagerService,
  CostItem,
  LoadingService,
  LocalStorageService,
  CompanyService,
  NameFilter,
  DataSyncService,
  SessionManagerService,
} from '@ops/shared-types';
import { TranslateService } from '@ngx-translate/core';
import { ActionMenuOption } from '../action-menu/action-menu.component';

export interface CompanyLite {
  _id: string;
  name: string;
}

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
})
export class ProjectsComponent implements OnInit, OnDestroy {
  timeout: any;
  // @Input() set selectedCompany(selectedCompany: Company) {
  //   if (selectedCompany?._id) {
  //     this.searchParam = '';
  //     if (this.timeout) {
  //       clearTimeout(this.timeout);
  //     }
  //     this.timeout = setTimeout(() => {
  //       const allProjects = this.localStorage.getAllProjects();
  //       this.displayedProjects = allProjects.sort((a: Project, b: Project) => {
  //         return b?.code?.localeCompare(a.code ?? '') ?? -1;
  //       });
  //     }, 600);
  //   }
  // }
  @Output() loadEstimate: EventEmitter<string> = new EventEmitter<string>();
  @Output() loadCost: EventEmitter<string> = new EventEmitter<string>();
  @Output() listMode: EventEmitter<boolean> = new EventEmitter<boolean>();

  focused: string;

  selectedCompany$;
  selectedProject: Project;

  gapSubs: Subscription;

  displayedProjects: Array<Project> = [];

  private refreshProjects$ = new BehaviorSubject<null>(null);
  searchParam = '';

  get existingProjects() {
    const searchParamUC = this.searchParam.toUpperCase();
    return [
      ...this.displayedProjects.filter(
        (p) =>
          // Filter out projects without fiscalYear or with canceled status
          // !p.fiscalYear && 
          p.status !== '4' && // Status 4 = Cancelled
          p.status !== '3' && // Status 3 = Submitted
          (p.name?.toUpperCase().includes(searchParamUC) ||
          p.client?.name?.toUpperCase().includes(searchParamUC) ||
          p.code?.toUpperCase().includes(searchParamUC))
      ),
    ];

    // return this.displayedProjects;
  }

  selectedProjectId: string;
  guestView = false;

  subscriptions: Array<Subscription> = [];

  constructor(
    private modalService: ModalService,
    private pm: ProjectManagerService,
    private companyService: CompanyService,
    private router: Router,
    private loadingService: LoadingService,
    private localStorage: LocalStorageService,
    private translateService: TranslateService,
    private dataSyncService: DataSyncService,
    private sessionManager: SessionManagerService
  ) {
    this.selectedCompany$ = this.companyService.selectedCompany$.asObservable();
  }

  selectedCompanySub: Subscription;

  ngOnInit(): void {
    // Subscribe to user role changes to determine guest view
    const userRoleSub = this.sessionManager
      .getUserRoleObservable()
      .subscribe((userRole: string) => {
        this.guestView = userRole === 'guest';
      });
    this.subscriptions.push(userRoleSub);

    this.selectedCompanySub = this.selectedCompany$.subscribe(
      (selCompany: NameFilter) => {
        // console.log("selectedCompany NameFilter", selCompany, "<= U project listi");

        if (this.gapSubs?.unsubscribe) {
          this.gapSubs.unsubscribe();
        }
        this.gapSubs = this.pm
          .getAllProjects(selCompany._id)
          .subscribe((projectsList: any) => {
            const allProjects = projectsList;
            // console.log("allProjects =====> ", allProjects);

            this.displayedProjects = allProjects.sort(
              (a: Project, b: Project) => {
                return b?.code?.localeCompare(a.code ?? '') ?? -1;
              }
            );

            // console.log("displayedProjects", this.displayedProjects.length);
          });
      }
    );
  }

  get isLoading(): boolean {
    return this.loadingService.getLoading();
  }

  ngOnDestroy(): void {
    if (this.gapSubs?.unsubscribe) {
      this.gapSubs.unsubscribe();
    }
    if (this.selectedCompanySub?.unsubscribe) {
      this.selectedCompanySub.unsubscribe();
    }
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onTypeSearch(event: any) {
    this.searchParam = event.target.value;
  }

  onClickEstimate(project: Project) {
    this.pm.setCurrentProject(project);

    this.router.navigate([`project-estimate`, 'project-info']);
  }

  onClickCost(project: Project) {
    this.router.navigate(['production-cost', project._id]);
  }

  onClickViewAll() {
    this.router.navigate(['project-list']);
  }

  onClickNewProject() {
    this.router.navigate(['create-project']);
  }

  onFocusItem(id: string) {
    if (this.focused === id) {
      this.focused = '';
      return;
    }
    this.focused = id;
  }

  onCostAdded(item: CostItem) { 
    const param2 = this.displayedProjects.find((p) => p._id === this.selectedProjectId)?.name ?? '';
    window.alert(
      this.translateService.instant('windowAlert.projects.costAdded', {
        itemName: item?.name ?? '',
        projectName: param2
      })
    );
  }

  onAddProjectCost(project: Project) {
    this.selectedProject = { ...project };
    // console.log(this.selectedProject);
    this.selectedProjectId = project._id;
    this.modalService.open('add-cost-modal-dashboard');
  }

  getDropdownOptions(project: Project): ActionMenuOption[] {
    const quickCost = this.translateService.instant('auth.projects.quickCost');
    const editProjectInfo = this.translateService.instant(
      'auth.projects.editProjectInfo'
    );
    const deleteProject = this.translateService.instant(
      'auth.projects.deleteProject'
    );
    const duplicateProject = this.translateService.instant(
      'projects.duplicateProject.title'
    );

    const options: ActionMenuOption[] = [
      { label: quickCost, value: quickCost },
      { label: editProjectInfo, value: editProjectInfo },
      { label: duplicateProject, value: duplicateProject },
    ];

    if (!project.isApproved) {
      options.push({ label: deleteProject, value: deleteProject, isDelete: true });
    }

    return options;
  }

  onSelectProjectAction(project: Project, action: string) {
    // this.closeModal('kebab' + projectId);
    const quickCost = this.translateService.instant('auth.projects.quickCost');
    const editProjectInfo = this.translateService.instant(
      'auth.projects.editProjectInfo'
    );
    const deleteProject = this.translateService.instant(
      'auth.projects.deleteProject'
    );
    const duplicateProject = this.translateService.instant(
      'projects.duplicateProject.title'
    );
    const underConstruction = this.translateService.instant(
      'auth.projects.underConstruction'
    );
    const deleteProjectConfirm = this.translateService.instant(
      'auth.projects.deleteProjectConfirm'
    );

    if (action === quickCost) {
      this.selectedProject = { ...project };
      // console.log(this.selectedProject);
      this.selectedProjectId = project._id;
    }
    switch (action) {
      case quickCost: {
        this.modalService.open('add-cost-modal-dashboard');
        this.dataSyncService.refetchVersionListener$.next(1);
        return;
      }
      case editProjectInfo: {
        this.modalService.open('project-info-modal', project);
        return;
      }
      case duplicateProject: {
        this.modalService.open('duplicate-project-modal', project);
        return;
      }
      case 'Archive Project': {
        const sub = this.pm.archiveProject(project._id).subscribe(() => {
          this.refreshProjects$.next(null);
          const deletedProjectId = this.displayedProjects.findIndex(
            (dp) => dp._id === project._id
          );
          this.displayedProjects.splice(deletedProjectId, 1);
          // this.element?.click();
        });
        this.subscriptions.push(sub);
        return;
      }
      case deleteProject: {
        if (
          confirm(
            this.translateService.instant('windowConfirm.projects.deleteProject', {
              projectName: this.displayedProjects.find((p) => p._id === project._id)?.name
            })
          )
        ) {
          const sub = this.pm.deleteProject(project._id).subscribe(() => {
            this.refreshProjects$.next(null);
            // const projects = this.displayedProjects;
            const deletedProjectId = this.displayedProjects.findIndex(
              (dp) => dp._id === project._id
            );
            this.displayedProjects.splice(deletedProjectId, 1);
            // this.displayedProjects = [];
            // this.displayedProjects = [...projects];
          });
          this.subscriptions.push(sub);
        }
        return;
      }
      default:
        break;
    }
  }

  private getSanitizeProjectCode(code: string): string {
    if (code?.startsWith('#')) {
      return code.substring(1);
    }
    return code;
  }

  editProject(project: Project) {
    let p = this.displayedProjects.find((p) => p._id === project._id);

    p.name = project.name;
    p.status = project.status; // Update the status as well

    p.client = { name: project.client.name, _id: project.client._id };
    p.billingCompany = project.billingCompany
      ? { name: project.billingCompany.name, _id: project.billingCompany._id }
      : null;

    this.displayedProjects = [...this.displayedProjects];

    this.dataSyncService.refetchVersionListener$.next(1);
  }

  onProjectDuplicated(data: {projectId: string, projectToInsert: Project}) {
    const duplicatedProject = this.displayedProjects.find((p) => p._id === data.projectId);
    if (duplicatedProject) {
      const index = this.displayedProjects.findIndex((p) => p._id === data.projectId);
      if (index !== -1) {
        this.displayedProjects.splice(index + 1, 0, data.projectToInsert);
      } else {
        this.displayedProjects.push(data.projectToInsert);
      }
    } else {
      this.displayedProjects.push(data.projectToInsert);
    }
    this.displayedProjects = [...this.displayedProjects];
    this.localStorage.setProjectById(data.projectId, data.projectToInsert);
  }
}
